import {
  MetaplanListResponseDto,
  MetaplanItemResponseDto,
  CreateMetaplanRequestDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import {
  SubscriptionsEndpoints,
  GET_METAPLANS_URL,
  DELETE_METAPLAN_URL,
  CREATE_METAPLAN_URL,
  subscriptionsTags,
} from './settings';

export interface GetMetaplansParams {
  page?: number;
  limit?: number;
  q?: string;
}

export type { MetaplanItemResponseDto, CreateMetaplanRequestDto };

export const subscriptionsApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [subscriptionsTags.metaplansList],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [SubscriptionsEndpoints.getMetaplans]: builder.query<
        MetaplanListResponseDto,
        GetMetaplansParams | void
      >({
        query: (params) => ({
          method: 'GET',
          url: GET_METAPLANS_URL,
          params: params || {},
        }),
        providesTags: [subscriptionsTags.metaplansList],
      }),
      [SubscriptionsEndpoints.deleteMetaplan]: builder.mutation<void, string>({
        query: (metaplanId) => ({
          method: 'DELETE',
          url: DELETE_METAPLAN_URL.replace(':metaplanId', metaplanId),
        }),
        invalidatesTags: [subscriptionsTags.metaplansList],
      }),
      [SubscriptionsEndpoints.createMetaplan]: builder.mutation<
        MetaplanItemResponseDto,
        CreateMetaplanRequestDto
      >({
        query: (body) => ({
          method: 'POST',
          url: CREATE_METAPLAN_URL,
          data: body,
        }),
        invalidatesTags: [subscriptionsTags.metaplansList],
      }),
    }),
  });

export const {
  useGetMetaplansQuery,
  useDeleteMetaplanMutation,
  useCreateMetaplanMutation,
} = subscriptionsApi;
